import { useListProductsQuery } from "api/memberPortal/product/product.api";
import { Product } from "api/memberPortal/project/product/product.types";
import { PRODUCT_STATUSES } from "api/memberPortal/project/product/productStatuses.type";

import ProductsInDraftTable from "./ProductsInDraftTable.table";

interface ProductsInDraftTableContainerProps {
  handleOpenDraft: () => void;
  setProduct: (_product: Product) => void;
}

function ProductsInDraftTableContainer({
  handleOpenDraft,
  setProduct,
}: ProductsInDraftTableContainerProps) {
  const { data: products, isFetching: isFetchingProducts } =
    useListProductsQuery({
      status: [PRODUCT_STATUSES.DRAFT],
      limit: 200,
    });

  const handleShowProductFormModal = (rowData: Product) => {
    setProduct(rowData);
    handleOpenDraft();
  };

  return (
    <ProductsInDraftTable
      products={products}
      isLoading={isFetchingProducts}
      handleShowProductFormModal={handleShowProductFormModal}
      setProduct={setProduct}
    />
  );
}

export default ProductsInDraftTableContainer;
